import { defineMessages } from 'react-intl-next';

export const messages: {
	placeholderDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	placeholderTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	placeholderTitle: {
		id: 'company-hub.carousel-extension.placeholder.title',
		defaultMessage: 'Give your frame a title',
		description:
			'Initial placeholder title of carousel frame to be displayed in the UI of the editor and view page.',
	},
	placeholderDescription: {
		id: 'company-hub.carousel-extension.placeholder.description',
		defaultMessage: 'Customize this frame to create a rotating carousel.',
		description:
			'Initial placeholder description of carousel frame to be displayed in the UI of the editor and view page.',
	},
});
